import React from "react"
import { Button } from "../util"

const PostBackButton = ({ data, onClick, isListButton, color }) =>
  (
    <Button
      isListButton={isListButton}
      color={color}
      onClick={() => {
        onClick({
          type: "postback",
          title: data.title,
          payload: data.payload,
        })
      }}
    >
      <div className="title">{data.title}</div>
    </Button>
  )

export default PostBackButton
